
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { MenuItemProps, MenuTreeItemProps } from ".";
import { loading, index, tree } from "store/menu";

interface ApiMenuInputProps {
    page: number;
    pageSize: number;
}

type ApiMenuOutputProps = OutputBaseProps<{ list: MenuItemProps[]; pagination?: PaginationProps; }>;

export const apiMenuIndex = async (data: ApiMenuInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMenuOutputProps>("/api/menus", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

type ApiMenuTreeOutputProps = OutputBaseProps<{ list: MenuTreeItemProps[]; }>

export const apiMenuTree = async () => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMenuTreeOutputProps>("/api/menu/tree", {}))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(tree({ data: res.data.list }));
    }
    return res;
};